import themeKey from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { hash } from '@ember/helper'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import type { TOC } from '@ember/component/template-only'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export const FastPhonicsNav: TOC<unknown> = <template>
  <TabGroupComponent
    class="mx-24"
    @theme={{themeKey SubscriptionType.Reading}}
    @tabType={{TAB_TYPE_KEYS.underline}}
    as |tabGroup|
  >
    <tabGroup.linkToTab @route="subscription-type.lessons.fast-phonics.previews">
      {{t "pages.product.lessons.tabs.index"}}
    </tabGroup.linkToTab>
    <tabGroup.linkToTab
      @route="subscription-type.lessons.fast-phonics.resources"
      @query={{hash resourceType="weekly_teaching_guide"}}
    >
      {{t "pages.product.lessons.tabs.resources"}}
    </tabGroup.linkToTab>
    <tabGroup.linkToTab
      @route="subscription-type.lessons.fast-phonics.resources"
      @query={{hash resourceType="teaching_powerpoint"}}
    >
      {{t "pages.product.lessons.tabs.slides"}}
    </tabGroup.linkToTab>
    <tabGroup.linkToTab @route="subscription-type.lessons.fast-phonics.videos">
      {{t "pages.product.lessons.tabs.videos"}}
    </tabGroup.linkToTab>
  </TabGroupComponent>
</template>

export default FastPhonicsNav
